import { render, staticRenderFns } from "./DocumentGeneratorPage.vue?vue&type=template&id=5ebf2d46&scoped=true"
import script from "./DocumentGeneratorPage.vue?vue&type=script&lang=js"
export * from "./DocumentGeneratorPage.vue?vue&type=script&lang=js"
import style0 from "./DocumentGeneratorPage.vue?vue&type=style&index=0&id=5ebf2d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf2d46",
  null
  
)

export default component.exports